import Clickable from 'components/Common/Clickable'
import LoyaltyTierIcon from 'components/Luxkit/Icons/loyalty/LoyaltyTierIcon'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import InlineIcon from 'components/utils/InlineIcon'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'
import FormatLoyaltyStatusCredits from 'loyalty/components/Formatters/FormatLoyaltyStatusCredits'
import React, { ComponentProps, MouseEventHandler, useCallback } from 'react'
import styled from 'styled-components'

const ClickableIcon = styled(Clickable)`
  // Vertically align the icon with text
  display: flex;
`

interface Props {
  tier: App.LoyaltyTier
  earnablePoints: number
  statusCredits?: number
  size: 'S' | 'M'
  onInfoIconClick?: MouseEventHandler<HTMLButtonElement>
  calculationType: 'estimate' | 'exact' | 'additional'
}

const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyTextBlock>['variant']> = {
  S: 'small',
  M: 'medium',
}

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum',
}

function PriceRowLoyaltyPoints({
  tier,
  earnablePoints,
  statusCredits,
  size,
  onInfoIconClick,
  calculationType,
}: Props) {
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onInfoIconClick?.(event)
  }, [onInfoIconClick])

  return <BodyTextBlock
    variant={SIZES_BODY_TEXT_VARIANTS[size]}
    colour={TIER_BODY_TEXT_COLOURS[tier]}
    weight="bold"
    startIcon={<LoyaltyTierIcon size="S" tier={tier} />}
  >
    <Group direction="horizontal" wrap="wrap" gap={4}>
      {calculationType === 'estimate' && <>Earn from <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
      {calculationType === 'exact' && <>Earn <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
      {calculationType === 'additional' && <>Earn an additional <FormatLoyaltyPoints abbreviated points={earnablePoints} /></>}
      <Group direction="horizontal" verticalAlign="center" gap={4} as="span" noDisplayWhenEmpty>
        {!!statusCredits && <> + <FormatLoyaltyStatusCredits statusCredits={statusCredits} /></> }
        {onInfoIconClick && <ClickableIcon onClick={handleClick}>
          <InlineIcon Icon={LineInfoCircleIcon} colour="neutral-one" />
        </ClickableIcon>}
      </Group>
    </Group>
  </BodyTextBlock>
}

export default PriceRowLoyaltyPoints
